import { v4 } from 'uuid'

type ObjectWithId = { id: string; [key: string]: any }

/** @todo Use generic identity type */
export const ensureUniqueObjectIds = (arr: ObjectWithId[]): typeof arr => {
    if (!Array.isArray(arr) || !arr.length) {
        return []
    }

    const ids = arr.filter((dash) => dash?.id && typeof dash.id === 'string').map((dash) => dash.id)
    const uniques = new Set(ids)

    if (uniques.size === arr.length) {
        return arr
    }

    return arr.map((item) =>
        item?.id && typeof item.id === 'string' && ids.indexOf(item.id) === ids.lastIndexOf(item.id)
            ? item
            : { ...item, id: v4() },
    )
}
